module.exports = __webpack_public_path__ + "img/indu_active_2.df876730.png";